import axios from "axios";
const actionUrl = process.env.VUE_APP_MAIL_SERVICE_URL;
const support = process.env.VUE_APP_SUPPORT;
const state = {};

const getters = {};

const mutations = {};

const actions = {
	sendMail({ commit }, payload) {
		commit('setLoading', true);
		axios.defaults.baseURL = actionUrl;
		axios.post('sendMail', {
			dest: payload.support ? payload.support : support,
			subject: payload.subject,
			html: payload.html
		}).then(()=>{
      commit('setLoading', false);
    });
	}
};

export default {
	state,
	getters,
	mutations,
	actions
};
